<template>
  <validation-provider
    #default="{ errors }"
    name="commitmentSituation"
    :rules="{
      required: requiredField,
    }"
  >
    <b-form-group
      label="Situação do Empenho"
      label-for="commitmentSituation"
    >
      <v-select
        id="commitmentSituation"
        v-model="commitmentSituation"
        :class="errors.length > 0 ? 'error-select' : ''"
        :options="commitmentSituationOptions"
        :placeholder="'Situação do Empenho'"
        :disabled="readonly"
        :clearable="!readonly"
      >
        <template #option="{ label }">
          {{ label }}
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  model: {
    prop: 'commitmentSituationValue',
    event: 'commitmentSituationChange',
  },
  props: {
    commitmentSituationValue: {
      type: [Object, Boolean],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      commitmentSituationOptions: [
        { label: 'Liberado', value: 'idle' },
        { label: 'Em Auditoria', value: 'audit' },
        { label: 'Concluido', value: 'done' },
        { label: 'Declinado', value: 'declined' },
      ],
    }
  },
  computed: {
    commitmentSituation: {
      get() {
        return this.commitmentSituationValue
      },
      set(value) {
        const valueMap = {
          idle: { label: 'Liberado', value: 'idle' },
          audit: { label: 'Em Auditoria', value: 'audit' },
          done: { label: 'Concluido', value: 'done' },
          declined: { label: 'Declinado', value: 'declined' },
        }

        this.$emit('commitmentSituationChange', valueMap[value] || value)
      },
    },
  },
  watch: {
    commitmentSituationValue(newVal) {
      this.commitmentSituation = newVal
    },
  },
  created() {
    this.$emit('ready', true)
  },
}
</script>

<style lang="scss">

.v-select {
  background-color: white;
}
</style>
